export const LANDING_SECTION_KEYS = [
  { key: 'encajaBanner', labelKey: 'blogAdmin.landingSectionEncajaBanner' },
  { key: 'domainSearch', labelKey: 'blogAdmin.landingSectionDomainSearch' },
  { key: 'offers', labelKey: 'blogAdmin.landingSectionOffers' },
  { key: 'conversionProof', labelKey: 'blogAdmin.landingSectionConversionProof' },
  { key: 'news', labelKey: 'blogAdmin.landingSectionNews' },
  { key: 'hero', labelKey: 'blogAdmin.landingSectionHero' },
  { key: 'heroStats', labelKey: 'blogAdmin.landingSectionHeroStats' },
  { key: 'services', labelKey: 'blogAdmin.landingSectionServices' },
  { key: 'process', labelKey: 'blogAdmin.landingSectionProcess' },
  { key: 'whyChoose', labelKey: 'blogAdmin.landingSectionWhyChoose' },
  { key: 'testimonials', labelKey: 'blogAdmin.landingSectionTestimonials' },
  { key: 'faq', labelKey: 'blogAdmin.landingSectionFaq' },
  { key: 'finalCta', labelKey: 'blogAdmin.landingSectionFinalCta' },
  { key: 'whatsappFab', labelKey: 'blogAdmin.landingSectionWhatsappFab' },
  { key: 'mobileStickyCta', labelKey: 'blogAdmin.landingSectionMobileStickyCta' },
  { key: 'footer', labelKey: 'blogAdmin.landingSectionFooter' }
];

export const DEFAULT_LANDING_SECTIONS = {
  encajaBanner: true,
  hero: false,
  heroStats: false,
  domainSearch: true,
  services: false,
  offers: true,
  conversionProof: false,
  process: false,
  whyChoose: false,
  testimonials: false,
  news: true,
  faq: false,
  finalCta: false,
  whatsappFab: true,
  mobileStickyCta: false,
  footer: true
};

/** Primary nav anchors on the marketing homepage (order matters). */
export const MARKETING_NAV_ITEMS = [
  { id: 'encaja', labelKey: 'landing.navEncaja', sectionKey: 'encajaBanner' },
  { id: 'dominio', labelKey: 'landing.navDomain', sectionKey: 'domainSearch' },
  { id: 'productos', labelKey: 'landing.navProducts', sectionKey: 'offers' },
  { id: 'servicios', labelKey: 'landing.navServices', sectionKey: 'services' },
  { id: 'proceso', labelKey: 'landing.navProcess', sectionKey: 'process' },
  { id: 'por-que', labelKey: 'landing.navWhy', sectionKey: 'whyChoose' },
  { id: 'clientes', labelKey: 'landing.navClients', sectionKey: 'testimonials' },
  { id: 'noticias', labelKey: 'landing.navNews', sectionKey: 'news' },
  { id: 'faq', labelKey: 'landing.navFaq', sectionKey: 'faq' }
];

export function mergeLandingSections(raw) {
  const merged = { ...DEFAULT_LANDING_SECTIONS };
  if (raw && typeof raw === 'object') {
    Object.keys(DEFAULT_LANDING_SECTIONS).forEach((key) => {
      if (raw[key] !== undefined) merged[key] = !!raw[key];
    });
  }
  return merged;
}

export function getVisibleMarketingNavItems(landingSections) {
  const sections = mergeLandingSections(landingSections);
  return MARKETING_NAV_ITEMS.filter((item) => sections[item.sectionKey]);
}
